<template>
    <div class="modal modal-info modal-info-1 fade" :id="modalId" tabindex="-1" role="dialog" :aria-labelledby="modalId" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4>
                        <div class="d-flex align-items-center flex-wrap">
                            <div
                                class="color mr-2"
                                :class="'background-color--c' + (event.colorId ?? event.calendar.color)"
                            ></div>
                            <div class="name">{{event.title}}</div>
                            <div
                                class="cal-time"
                                v-if="event.transformed_all_day"
                            >
                                {{formatDateTimeRangeForAllDay(event.start_date, event.end_date)}}
                            </div>
                            <div
                                class="cal-time"
                                v-else
                            >
                                {{formatDateTimeRange(event.start_date, event.end_date)}}
                            </div>
                        </div>

                    </h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    </button>
                </div>
                <div class="modal-body">
                    <div class="modal-inner">
                        <div>
                            <div class="modal-calendar-info" v-if="event.client_id">
                                <img class="icon" src="/img/svg/map-3.svg">
                                <span>{{event.client.name ?? ''}}</span>
                            </div>
                            <div
                                class="modal-calendar-info"
                                v-if="event.guests.length > 0"
                            >
                                <img class="icon" src="/img/svg/group1.svg">
                                <span v-if="event.guests"> {{event.guests.length}} guests</span>
                                <div
                                    v-for="guest in event.guests"
                                    :key="guest.id"
                                >
                                    <div> {{guest.app_user.name ?? ''}} {{guest.app_user.last_name ?? ''}}</div>
                                </div>
                            </div>
                            <div
                                class="modal-calendar-info"
                                v-if="event.notes"
                                style="display: flex"
                            >
                                <img class="icon" src="/img/svg/pen.svg">
                                <div v-html="htmlNotes"></div>
                            </div>
                            <div class="modal-calendar-info" v-if="event.notifications.length > 0">
                                <img class="icon" src="/img/svg/bell.svg">
                                <span
                                    v-for="notification in event.notifications"
                                    :key="notification.id"
                                >
                                    {{ notification.reminder_time }} {{ notification.reminder_unit }} before;
                                </span>
                            </div>
                            <div class="modal-calendar-info" >
                                <img class="icon" src="/img/svg/calendar-6.svg">
                                <span>{{event.calendar.name  ?? ''}}</span>

                                <div v-if="event.creator" class="mt-2">
                                    Created by: {{ event.creator.name ?? '' }} {{ event.creator.last_name ?? '' }}
                                </div>
                                <div v-if="event.updated_by" class="mt-2">
                                    Edited by: {{ event.updated_by.name ?? '' }} {{ event.updated_by.last_name ?? '' }}
                                </div>
                            </div>

                            <div
                                class="modal-calendar-info"
                                v-if="event.status === 'done'"
                            >
                                <img class="icon" src="/img/svg/status.svg">
                                <span>Done</span>
                            </div>
                            <div
                                class="modal-calendar-info"
                                v-if="event.status === 'missed'"
                            >
                                <img class="icon" src="/img/svg/material-symbols_call-missed-rounded.svg">
                                <span>Missed</span>
                            </div>
                        </div>
                        <div class="btns-wrap">
                            <button
                                @click.prevent="$emit('delete', event.id)"
                                class="btn btn--outline-primary"
                            >Delete</button>
                            <a :href="`/master-admin/calendar/event/${event.id}/update`" class="btn btn--secondary">Edit</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import DateConverter from "../../../../../resources/js/mixins/DateConverter";
import DeactivationPage from "../../../Applicants/resources/js/related/DeactivationPage.vue";

export default {
    name: 'EventInfoModal',
    components: {DeactivationPage},
    mixins: [DateConverter],
    props: {
        modalId: {
            type: String,
            required: true,
        },
        event: {
            type: Object,
            required: true,
        },
    },
    emits: ['delete'],
    computed: {
        htmlNotes() {
            return this.event.notes
        }
    },

}

</script>



<style scoped>

</style>
